<template>
  <IconField>
    <InputIcon v-if="icon">
      <Icon :icon="icon" class='size-4' :class="setIconColor"/>
    </InputIcon>
    <Tag
      :value="value"
      :severity="tone"
      :rounded="rounded"
      :pt="{
        root: {
          class: [
            'text-nowrap'
          ]
        },
        label: {
          // To handle the spacing once an icon is passed in
          class: [
            icon ? 'ml-7 pr-1.5' : null,
            nullable ? 'mr-5' : null,
            fontSize
          ]
        }
      }"
    />
    <InputIcon v-if="nullable" class="cursor-pointer right-1" @click="emit('clear', value)">
      <Icon icon="heroicons:x-mark" class='size-4' :class="setIconColor"/>
    </InputIcon>
  </IconField>
</template>

<script setup>
import { computed } from "vue";
import Tag from 'primevue/tag'
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import { Icon } from '@iconify/vue'

const props = defineProps({
  value: {
    type: String
  },
  tone: {
    type: String,
    validator: (val) => [null, 'secondary', 'success', 'info', 'warn', 'danger', 'contrast'].includes(val),
    default: null
  },
  size: {
    type: String,
    validator: (val) => ['xsmall', 'small', 'large'].includes(val),
    default: 'small'
  },
  rounded: {
    type: Boolean
  },
  icon: {
    type: String
  },
  iconColor: {
    type: String
  },
  nullable: {
    type: Boolean
  }
})

const emit = defineEmits(['clear'])

const setIconColor = computed(() => {
  // If user passes in Icon Color to the Tag Component, bypass severity color
  if (props.iconColor) {
    return props.iconColor
  }
  // This returns the same colors as the severity color labels like the Tag PrimeVue Docs do.
  return {
    null: 'text-[#612BD2] dark:text-[#AC98FC]',
    secondary: 'text-[#475569] dark:text-[#D4D4D8]',
    success: 'text-[#16803C] dark:text-[#87EEAB]',
    info: 'text-[#0568A0] dark:text-[#7CD3FC]',
    warn: 'text-[#C1410B] dark:text-[#FDBA74]',
    danger: 'text-[#B91C1B] dark:text-[#FCA5A5]',
    contrast: 'text-[#FFFFFF] dark:text-[#09090B]'
  }[props.tone]
})

const fontSize = computed(() => {
  return {
    'xsmall': 'text-xs',
    'small': 'text-sm',
    'large': 'text-lg',
  }[props.size]
})
</script>